declare namespace $ {

	type $shm_hitalama_components_demo__definition_shm_hitalama_components_fullscreen_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_fullscreen['definition'] >
		,
		ReturnType< $shm_hitalama_components_demo['definition'] >
	>
	type $shm_hitalama_components_demo__kind_shm_hitalama_components_fullscreen_2 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_components_demo['kind'] >
	>
	export class $shm_hitalama_components_fullscreen extends $mol_scroll {
		definition( ): $shm_hitalama_map_widget_entity_custom
		content( ): readonly($mol_view)[]
		fqn( ): string
		demo_model( ): $shm_hitalama_components_demo
		sub( ): ReturnType< $shm_hitalama_components_fullscreen['content'] >
	}
	
}

//# sourceMappingURL=fullscreen.view.tree.d.ts.map